import React, {Component} from "react";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PageBlock from "../common/PageBlock";
import SubscriptionService from "../service/SubscriptionService";
import "./Subscribe.css";
import PriceItem from "../common/PriceItem";
import {Link} from "react-router";
import Fade from "react-fade";
import {currentSiteName} from "../service/SiteService";

const fadeDuration = 0.6;

class Subscribe extends Component {
    constructor() {
        super();

        this.state = {
            stripeReady: false,
            product: {},
            steps: []
        };

        this.setUpPayment = this.setUpPayment.bind(this);
        this.openPaymentForm = this.openPaymentForm.bind(this);
        this.showStep = this.showStep.bind(this);
        this.getStepVisible = this.getStepVisible.bind(this);
        this.isStepVisible = this.isStepVisible.bind(this);
    }

    componentDidMount() {
        SubscriptionService.fetchDefaultProductId((productId) => {
            SubscriptionService.fetchProduct(productId, (product) => {
                this.setState({
                    product: product
                });

                // show once product loaded
                this.showStep(1);

                this.setUpPayment(product);
            });
        });
    }

    setUpPayment(product) {
        const onSetupComplete = (setupSuccess) => {
            if (setupSuccess) {
                this.setState({
                    stripeReady: true
                });
            }
        };

        const onSubscriptionSuccess = () => {
            window.location.href = '/subscription';
        };

        SubscriptionService.setUpPayment(product, onSetupComplete, onSubscriptionSuccess);
    }

    openPaymentForm() {
        SubscriptionService.openPaymentForm(this.state.product);
    }

    /**
     * Show the given step.
     *
     * @param stepNumber {Number}
     */
    showStep(stepNumber) {
        const maxSteps = 3;
        let steps = [];

        for (let i = 0; i < maxSteps; i++) {
            steps.push({
                visible: (i === stepNumber - 1)
            });
        }

        this.setState({
            steps: steps
        });
    }

    getStepVisible() {
        for (let i = 0; i < this.state.steps.length; i++) {
            let step = this.state.steps[i];
            if (step && step.visible) {
                return i + 1;
            }
        }
        return 0;
    }

    isStepVisible(stepNumber) {
        let step = this.state.steps[stepNumber - 1];
        return step && step.visible;
    }

    render() {
        return (
            <div>
                <TopNav tab="subscription"/>

                <PageBlock>
                    <div className="container">
                        <div className="row m-t-md">
                            <div className="col-lg-12 m-t-sm m-b-sm">
                                <h2 className="payment-header"><span className="number-circle">1</span> Subscribe
                                    {this.getStepVisible() > 1 &&
                                    <button type="button" className="btn btn-default pull-right"
                                            onClick={() => this.showStep(1)}>Show
                                    </button>}
                                </h2>
                            </div>

                            {this.isStepVisible(1) &&
                            <Fade duration={fadeDuration}>
                                <PriceItem
                                    title="Individual"
                                    description="The perfect size for a single project."
                                    price="3"
                                    limitColumns={12}
                                    featuresVisible={false}
                                    buttonVisible={false}
                                    xPadding={false}
                                    yPadding={false}
                                />
                                <div className="col-lg-12 m-b-md">
                                    <Link className="btn btn-default" to="/subscription">Go back</Link>
                                    <button type="button" className="btn btn-primary pull-right"
                                            onClick={() => this.showStep(2)}>Continue
                                    </button>
                                </div>
                            </Fade>}
                        </div>

                        {/* plan details */}
                        <div className="row">
                            <div className="col-lg-12 m-t-sm m-b-sm">
                                <h2 className="payment-header"><span className="number-circle">2</span> Plan details
                                    {this.getStepVisible() > 2 &&
                                    <button type="button" className="btn btn-default pull-right"
                                            onClick={() => this.showStep(2)}>Show
                                    </button>}
                                </h2>
                            </div>

                            {this.isStepVisible(2) &&
                            <Fade duration={fadeDuration}>
                                <div className="col-lg-12 m-t-md">
                                    This plan gives you the following benefits:
                                </div>
                                <PriceItem
                                    title={this.state.product.title}
                                    headerVisible={false}
                                    limitColumns={12}
                                    features={[
                                        <span><strong>1,000</strong> monthly deployments</span>,
                                        <span><strong>history</strong> of your builds</span>,
                                        <span><strong>logs</strong> in real-time</span>
                                    ]}
                                    featureSpacersVisible={false}
                                    buttonVisible={false}
                                    xPadding={false}
                                    yPadding={false}
                                />
                                <div className="col-lg-12 m-b-md">
                                    <button type="button" className="btn btn-primary pull-right" style={{marginTop: -70}}
                                            onClick={() => this.showStep(3)}>Continue
                                    </button>
                                </div>
                            </Fade>}
                        </div>

                        {/* payment */}
                        <div className="row">
                            <div className="col-lg-12 m-t-sm m-b-sm">
                                <h2 className="payment-header"><span className="number-circle">3</span> Payment <span className="hidden-xs">&amp; billing</span> details</h2>
                            </div>

                            {this.isStepVisible(3) &&
                            <Fade duration={fadeDuration} className="m-t-md m-b-lg">
                                {/* spacer */}
                                <div className="m-t-sm visible-lg">&nbsp;</div>

                                <div className="col-sm-7">
                                    <p>
                                        On clicking <strong>Pay with Card</strong> the secure payment form will appear.
                                    </p>
                                    <div className="panel panel-info payment-provider-panel">
                                        <div className="panel-body">
                                            <i className="icon icon-lock"/> {currentSiteName} uses <Link target="_blank" href="https://stripe.com">Stripe</Link>, so
                                            you can pay with confidence, safe in the knowledge that your payment information is secure.
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    {!this.state.stripeReady &&
                                    <span className="pull-right"><i className="icon icon-circular-graph"/> Loading...</span>
                                    }

                                    {this.state.stripeReady &&
                                    <button type="button" className="btn btn-primary pull-right" onClick={this.openPaymentForm}>Pay with Card</button>
                                    }
                                </div>
                            </Fade>}
                        </div>
                    </div>
                </PageBlock>

                <Footer/>
            </div>
        )
    }
}

export default Subscribe;



// WEBPACK FOOTER //
// ./src/modules/views/Subscribe.js